export interface WaybillOverviewLocation {
  extId?: string;
  name: string;
  address: string;
}

export interface WaybillOverviewTransportDetails {
  transportMode: string;
  transportService: string;
  carriageConditions: string[];
}

export interface WaybillOverviewIdentificationNumbers {
  houseBillOfLading: string;
  masterBillOfLading: string;
  houseAirwayBill: string;
  masterAirwayBill: string;
}

export interface WaybillOverviewData {
  waybillNumber: string;
  carriersNames: string[];
  statusCodeDescription: string;
  origin: WaybillOverviewLocation;
  destination: WaybillOverviewLocation;
  transportDetails: WaybillOverviewTransportDetails;
  identificationNumbers: WaybillOverviewIdentificationNumbers;
}
